import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import SideBar from '../commun/SideBar';
import Hearder from '../commun/Hearder';
import swal from "sweetalert";
import { useEffect, useState } from 'react';
import { getPropertylocation, SavePropertyloaction } from '../../Services/Service';

const ProprtyLocation = () => {
  const [loading, setLoading] = useState(false);

  const [Propertylocationformdata, setPropertyLocationFormData] = useState({
    Address: '',
  });

  useEffect(() => {
    const getPropertylocations = async () => {
      setLoading(true);
      try {
        const result = await getPropertylocation();
        if (result && result.length > 0) {
          setPropertyLocationFormData(result[0]);
        }
      }
      catch (error) {
        console.log("error getting property location", error);
      } finally {
        setLoading(false);
      }
    }
    getPropertylocations();
  }, []);



  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const address = Propertylocationformdata.Address;

      if (!address.trim()) {
        alert("Please enter a location before submitting.");
        return;
      }

      const result = await SavePropertyloaction(address);
      console.log("Location saved successfully", result);

      swal("Location Saved Successfully", {
        icon: "success",
        buttons: {
          confirm: {
            text: "OK",
            className: "btn btn-success",
          },
        },
      });
    } catch (error) {
      alert("Failed to save location. Please try again.");
    } finally {
      setLoading(false);
    }
  };




  return (
    <>

      {loading && (
        <FullScreenLoader />
      )}

      <div className="wrapper">
        <SideBar />
        <div className="main-panel">
          <Hearder />
          <div className="container">
            <div className="page-inner">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Property Location & Direction </div>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit} >
                        <div className="row">
                          <div className="col-md-12">
                            <div className="input-block mb-3">
                              <label className="col-form-label">Address</label>
                              <textarea rows="2" className="form-control" placeholder="Enter Direction" value={Propertylocationformdata.Address} onChange={(e) => setPropertyLocationFormData({ ...Propertylocationformdata, Address: e.target.value })} required></textarea>
                            </div>
                          </div>
                        </div>
                        <div className="card-action text-end">
                          <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                      </form>
                    </div>
                  </div>
                  {/* <div className="map_main ">
                    <div className="map-responsive ">
                      <iframe
                        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA0s1a7phLN0iaD6-UE7m4qP-z21pH0eSc&amp;q=Eiffel+Tower+Paris+France" width="250" height="500" frameBorder="0" style={{ border: "0", width: "100%" }} allowFullScreen title="Map showing the location of the Eiffel Tower in Paris, France" />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

        </div>
      
      </div>
    </>
  );
};

export default ProprtyLocation;
